import styled, { css } from 'styled-components';
import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import { palette } from 'src/styles/colors';

export const MeetMightyProStaticContainer = styled.div`
  max-width: 100vw !important;
  height: auto;
  width: 100%;
  display: flex;
  background: linear-gradient(0deg, ${palette.spruce}, ${palette.spruce}); // custom background
  position: relative;
`;

export const RadialBackgroundStaticContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  background: radial-gradient(71.35% 71.35% at 50% 100%, rgba(162, 209, 208, 0.46) 0%, rgba(161, 208, 207, 0) 100%);
  position: relative;
  justify-content: center;
  align-items: center;

  ${applyStylesToMobileExperience(css`
    height: auto;
  `)}
`;

export const MeetMightyProStaticContent = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 6rem 1.5rem 6rem;
  height: fit-content;

  ${applyStylesToMobileExperience(css`
    max-width: 560px;
    padding: 3rem 1.5rem 3rem;
  `)}
`;
